import styled from "styled-components";

import { Button } from "shared/ui";
import { colors, radii } from "shared/ui/tokens";

// Кнопки подвала выравниваются по левому краю списка — это раскладка, а не тема кнопки,
// поэтому правится здесь, а не пропсами кита.
export const FooterButton = styled(Button)`
    height: 40px;
    justify-content: flex-start;
    padding: 0 12px;
`;

export const Wrap = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
`;

export const ROW_HEIGHT = 44;

// Сколько строк максимум показываем без прокрутки. Дальше список скроллится, а карточка
// перестаёт расти — иначе меню на 70 категорий вытянуло бы сайдбар на несколько экранов.
export const MAX_VISIBLE_ROWS = 12;

export const List = styled.ul<{ $rows: number }>`
    list-style: none;
    margin: 4px 0 0;
    /* Высота считается по ПОЛНОМУ числу категорий, а не по отфильтрованному: иначе
       карточка прыгала бы на каждую букву в поиске. min() — чтобы на низком окне
       список не вылезал за экран. */
    height: min(${({ $rows }) => $rows * ROW_HEIGHT}px, 60vh);
    /* Полоса прокрутки уведена влево: справа за край и так борются счётчик позиций и
       кнопка «⋯», и скроллбар оказывался прямо под ней. Смена direction — единственный
       способ её перенести, поэтому строкам ниже возвращаем ltr. */
    direction: rtl;
    padding: 0 2px 0 8px;
    display: flex;
    flex-direction: column;
    overflow-y: auto;

    scrollbar-width: thin;
    scrollbar-color: rgba(0, 0, 0, 0.18) transparent;

    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-track {
        background: transparent;
    }

    &::-webkit-scrollbar-thumb {
        border-radius: 3px;
        background: rgba(0, 0, 0, 0.18);
    }
`;

export const Row = styled.li<{ $active: boolean }>`
    list-style: none;
    /* Возвращаем нормальное направление после rtl-приёма на списке. */
    direction: ltr;
    flex: none;
    display: flex;
    align-items: center;
    border-radius: ${radii.order};
    background: ${({ $active }) => ($active ? "rgba(25,118,210,0.08)" : "transparent")};

    &:hover {
        background: ${({ $active }) =>
            $active ? "rgba(25,118,210,0.08)" : "rgba(0,0,0,0.03)"};
    }
`;

export const RowButton = styled.button<{ $active: boolean; $muted: boolean }>`
    flex: 1 1 auto;
    min-width: 0;
    height: 44px;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 0 12px;
    border: none;
    border-radius: ${radii.order};
    background: transparent;
    font-family: inherit;
    font-size: 14px;
    font-weight: ${({ $active }) => ($active ? 600 : 400)};
    color: ${({ $active, $muted }) => {
        if ($active) return colors.primary;
        return $muted ? colors.textSecondary : colors.textPrimary;
    }};
    text-align: left;
    cursor: pointer;
`;

export const StopDot = styled.span`
    flex: none;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: ${colors.danger};
`;

export const Name = styled.span`
    flex: 1 1 auto;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const Count = styled.span<{ $active: boolean }>`
    flex: none;
    font-size: 13px;
    ${({ $active }) =>
        $active
            ? `font-weight: 700; opacity: .7;`
            : `font-weight: 400; color: ${colors.textSecondary};`}
`;

export const Divider = styled.div`
    height: 1px;
    margin: 6px 0;
    background: ${colors.borderSoft};
`;

// Живёт внутри списка, а не вместо него: подмена содержимого не должна менять высоту блока.
export const Empty = styled.li`
    direction: ltr;
    list-style: none;
    margin: 8px 12px;
    font-size: 13px;
    color: ${colors.textSecondary};
`;
